(() => {
  if (customElements.get('lr-cart-image')) return;
  const mapUrl = 'https://cdn.shopify.com/s/files/1/0904/4993/6685/files/lr-replacement-lens-media.json';
  let mediaMap;
  const token = value => String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const safeUrl = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com') return null;
      url.searchParams.set('width', '300');
      return url.href;
    } catch (_) { return null; }
  };
  customElements.define('lr-cart-image', class extends HTMLElement {
    connectedCallback() {
      // Upgrades also run when Shopify replaces cart sections through AJAX.
      if (this.started) return;
      this.started = true;
      this.resolveImage();
    }
    async resolveImage() {
      const img = this.querySelector('img');
      if (!img) return;
      const reveal = () => {
        img.style.visibility = '';
        this.closest('.skeleton-box')?.classList.remove('skeleton-box');
      };
      img.onload = reveal;
      img.onerror = () => {
        img.onerror = reveal;
        img.src = img.dataset.fallback;
      };
      try {
        const rawProperties = JSON.parse(this.dataset.properties || '{}');
        const properties = Array.isArray(rawProperties) ? Object.fromEntries(rawProperties) : rawProperties;
        let cache = {};
        try { cache = JSON.parse(sessionStorage.getItem('cartImageData') || '{}') || {}; } catch (_) {}
        for (const [filter, color] of Object.entries(properties)) {
          if (filter.startsWith('_')) continue;
          const cached = safeUrl(cache[`${this.dataset.variant}_${color}_${filter}`]?.imageUrl);
          if (cached) { img.src = cached; return; }
        }
        // The same historical image map as the PDP supports restored/cross-session carts.
        if (!mediaMap) {
          mediaMap = fetch(mapUrl, {signal: AbortSignal.timeout(5000)})
            .then(r => { if (!r.ok) throw new Error('Lens media unavailable'); return r.json(); })
            .catch(error => { mediaMap = null; throw error; });
        }
        const map = await mediaMap;
        for (const [filter, color] of Object.entries(properties)) {
          const file = map.products?.[this.dataset.handle]?.[token(filter)]?.[token(color)]?.[0];
          const selected = file && safeUrl(file.startsWith('https://') ? file : map.cdnBase + file);
          if (selected) { img.src = selected; return; }
        }
      } catch (_) { /* Keep the cart usable if storage or the media service is unavailable. */ }
      img.src = img.dataset.fallback;
    }
  });
})();
